export enum AppVersions {
  WN = 'WACKER_NEUSON',
  OSP = 'ONESTOP_PRO',
}
